<template>
    <form @submit.prevent="onSubmit" class="form-horizontal form-material">
        <div class="card text-white bg-danger" v-if="showFailureMessage">
            <div class="card-header">
                <h4 class="m-b-0 text-white">Validation Errors</h4></div>
            <div class="card-body">
                <p v-if="typeof errors === 'string'" class="card-text">{{errors}}</p>
                <p v-else class="card-text" v-for="(error, key) in errors" :key="key">
                    {{key}}: {{error}}
                </p>
            </div>
        </div>
        <br/>

        <div class="mb-5" v-if="this.$store.getters.isAdmin">
            <label>Owner:</label>
            <treeselect placeholder="Select"
                        v-model="server.user"
                        :multiple="false"
                        :options="userList"
                        :load-options="loadUserList"
                        value-format="object"
            />
        </div>
        <div class="form-group">
            <label class="my-1">Server Name</label>
            <input v-model="server.name" type="text" class="form-control">
            <div v-if="$v.server.name.$error">
                <div class="text-danger" v-if="!$v.server.name.required">Server Name is required.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Server IP</label>
            <input v-model="server.serverIp" type="text" class="form-control">
            <div v-if="$v.server.serverIp.$error">
                <div class="text-danger" v-if="!$v.server.serverIp.required">Server IP is required.</div>
                <div class="text-danger" v-if="!$v.server.serverIp.ipAddress">Server IP must be an valid IP address.
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">PMTA HTTP Port</label>
            <input v-model.number="server.pmtaHttpPort" type="text" class="form-control">
            <div v-if="$v.server.pmtaHttpPort.$error">
                <div class="text-danger" v-if="!$v.server.pmtaHttpPort.required">PMTA HTTP Port is required.</div>
                <div class="text-danger" v-if="!$v.server.pmtaHttpPort.integer">PMTA HTTP Port must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">SSH Port</label>
            <input v-model.number="server.sshPort" type="text" class="form-control">
            <div v-if="$v.server.sshPort.$error">
                <div class="text-danger" v-if="!$v.server.sshPort.required">SSH Port is required.</div>
                <div class="text-danger" v-if="!$v.server.sshPort.integer">SSH Port must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">SMTP Port</label>
            <input v-model.number="server.smtpPort" type="text" class="form-control">
            <div v-if="$v.server.smtpPort.$error">
                <div class="text-danger" v-if="!$v.server.smtpPort.required">SSH Port is required.</div>
                <div class="text-danger" v-if="!$v.server.smtpPort.integer">SSH Port must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Inbound encryption</label>
            <input v-model="server.encryption" type="text" class="form-control">
            <div v-if="$v.server.encryption.$error">
                <div class="text-danger" v-if="!$v.server.encryption.encryptOptions">Empty or 'ssl' or 'tls'</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">SSH Username</label>
            <input v-model="server.serverUsername" type="text" class="form-control">
            <div v-if="$v.server.serverUsername.$error">
                <div class="text-danger" v-if="!$v.server.serverUsername.required">SSH Username is required.</div>
                <div class="text-danger" v-if="!$v.server.serverUsername.minLength">
                    SSH Username must have at least {{$v.server.serverUsername.$params.minLength.min }} characters.
                </div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Default normal relay speed(seconds between sending).</label>
            <input v-model.number="server.relayNormalSpeed" type="text" class="form-control">
            <div v-if="$v.server.relayNormalSpeed.$error">
                <div class="text-danger" v-if="!$v.server.relayNormalSpeed.required">Normal Relay speed is required.</div>
                <div class="text-danger" v-if="!$v.server.relayNormalSpeed.integer">Normal Relay speed must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">Default backoff relay speed(seconds between sending).</label>
            <input v-model.number="server.relayBackoffSpeed" type="text" class="form-control">
            <div v-if="$v.server.relayBackoffSpeed.$error">
                <div class="text-danger" v-if="!$v.server.relayBackoffSpeed.required">Backoff Relay speed is required.</div>
                <div class="text-danger" v-if="!$v.server.relayBackoffSpeed.integer">Backoff Relay speed must be integer.</div>
            </div>
        </div>
        <div class="form-group">
            <label class="mb-1">IP List for Admin Access</label>
            <input v-model="server.ipList" type="text" class="form-control">
            <div v-if="$v.server.ipList.$error">
                <div class="text-danger" v-if="!$v.server.ipList.required">IP List is required.</div>
            </div>
        </div>
        <div class="form-group text-center p-b-20">
            <div class="col-xs-12">
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" v-show="!submitting">
                    Save
                </button>
                <button class="btn btn-info btn-rounded text-uppercase waves-effect waves-light" disabled
                        v-show="submitting">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    Submitting...
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {integer, ipAddress, minLength, required} from 'vuelidate/lib/validators';
    import PmtaServerService from '../../services/PmtaServerService';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../../services/UserService';

    const encryptOptions = (value) => ['ssl', 'tls', '', null].includes(value);

    export default {
        name: 'PmtaServerForm',
        props: ['id'],
        components: {Treeselect},
        data() {
            return {
                server: {
                    name: null,
                    serverIp: null,
                    pmtaHttpPort: 8080,
                    sshPort: 22,
                    smtpPort: 3535,
                    encryption: null,
                    serverUsername: 'root',
                    relayNormalSpeed: 60,
                    relayBackoffSpeed: 600,
                    ipList: null,
                    user: null
                },
                errors: {},
                showFailureMessage: false,
                userList: null,
                submitting: false,
            }
        },
        mounted() {
            if (this.id) {
                PmtaServerService.getServer(this.id).then(response => {
                    this.server = response.data;
                    this.$emit('hidePreloader', false)
                });
            }
        },
        validations: {
            server: {
                name: {required},
                serverIp: {required, ipAddress},
                pmtaHttpPort: {required, integer},
                sshPort: {required, integer},
                smtpPort: {required, integer},
                encryption: {encryptOptions},
                serverUsername: {required, minLength: minLength(4)},
                relayNormalSpeed: {required, integer},
                relayBackoffSpeed: {required, integer},
                ipList: {required},
            }
        },
        methods: {
            onSubmit() {
                this.$v.$touch();
                if (this.$v.$invalid) return;
                if (!this.server.user) {
                    delete this.server.user;
                }

                this.server.encryption = this.server.encryption || null;

                let submitMethod = null;
                if (this.id) {
                    submitMethod = PmtaServerService.updateServer(this.id, JSON.stringify(this.server));
                } else {
                    submitMethod = PmtaServerService.createServer(JSON.stringify(this.server));
                }

                submitMethod.then(response => {
                    if ([200, 201].includes(response.status)) {
                        this.$router.push({name: 'pmtaServers'});
                    }
                    this.submitting = false;
                    this.errors = response.data.error !== undefined ? response.data.error : 'Some error occurred.';
                    this.showFailureMessage = true;
                });
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            }
        }
    }
</script>

<style scoped>

</style>
